import { render, staticRenderFns } from "./PageMask.vue?vue&type=template&id=6c5d1443&scoped=true&"
import script from "./PageMask.vue?vue&type=script&lang=js&"
export * from "./PageMask.vue?vue&type=script&lang=js&"
import style0 from "./PageMask.vue?vue&type=style&index=0&id=6c5d1443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5d1443",
  null
  
)

export default component.exports